app.locations = {

    settings: {
        $map: $('#map'),
        $form: $("#form-closest-location"),
        $notification: $('.header-aside__notification'),
        image: '/assets/dist/img/gm-marker.png',
        imageSelected: '/assets/dist/img/gm-marker-selected.png',
    },

    markers: [],
    selectedMarker: null,

    init: function() {

        if (app.locations.settings.$map.length > 0) {

            var script = document.createElement('script');

            script.type = 'text/javascript';
            script.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry&callback=app.locations.createMap&key=' + gMapsKey;
            document.body.appendChild(script);
        }

        $('[data-city]').on('click', function(e) {

            e.preventDefault();

            var selectedCity = $(this).data('city');

            $.each(app.locations.markers, function(index, marker){

                if (selectedCity === marker.handle) {

                    marker.setIcon(app.locations.settings.imageSelected);
                    app.locations.selectedMarker = marker;
                }
                else {

                    marker.setIcon(app.locations.settings.image);
                }
            });

            app.locations.applyFilter(selectedCity);
        });

        app.locations.settings.$form.on('submit', function(e) {

            e.preventDefault();

            app.locations.selectClosestMarker();
        });
    },

    createMap: function() {

        // google.maps.event.addDomListener(window, 'load', init);

        // Basic options for a simple Google Map
        // For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
        var mapOptions = {
            // How zoomed in you want the map to start at (always required)
            zoom: 9,

            // The latitude and longitude to center the map (always required)
            center: new google.maps.LatLng(53.05194551917203, 6.2738800048828125),

            // How you would like to style the map.
            // This is where you would paste any style found on Snazzy Maps.
            //styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#6195a0"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#e6f3d6"},{"visibility":"on"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45},{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#f4d2c5"},{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"labels.text","stylers":[{"color":"#4e4e4e"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#f4f4f4"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#787878"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#eaf6f8"},{"visibility":"on"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#eaf6f8"}]}]
            styles: [
            {
                "featureType": "administrative.country",
                "elementType": "geometry",
                "stylers": [
                {
                    "visibility": "simplified"
                },
                {
                    "hue": "#ff0000"
                }
                ]
            }
            ]
        };

        // Get the HTML DOM element that will contain your map
        // We are using a div with id="map" seen below in the <body>
        // var mapElement = document.getElementById('map');

        // Create the Google Map using our element and options defined above
        var map = new google.maps.Map(app.locations.settings.$map[0], mapOptions);

        $.each(locationData, function(index, value) {

            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(value.lat, value.lng),
                map: map,
                title: value.title,
                icon: app.locations.settings.image,
                handle: value.handle
            });

            app.locations.markers.push(marker);

            marker.addListener('click', function() {

                if ( app.locations.selectedMarker !== null ) {

                    app.locations.selectedMarker.setIcon(app.locations.settings.image);
                }

                marker.setIcon(app.locations.settings.imageSelected);

                app.locations.selectedMarker = marker;

                app.locations.applyFilter(marker.handle);
            });

            marker.addListener('mouseover', function(){
                marker.setIcon(app.locations.settings.imageSelected);
            });

            marker.addListener('mouseout', function(){
                if(  app.locations.selectedMarker !== marker ) {
                    marker.setIcon(app.locations.settings.image);
                }
            });
        });
    },

    applyFilter: function(handle) {

        $('[data-city-container]').hide();

        $('[data-city-container]').each(function() {

            if ( handle === $(this).data('cityContainer') ) {

                $(this).fadeIn();
                app.jump.to('#locations-container');
            }
        });
    },

    selectClosestMarker: function() {

        var zipCode = app.locations.settings.$form.find('[name=zipcode]').val().replace(' ', '');

        app.locations.settings.$notification.animate({opacity: 0}, 100);

        if ( /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i.test(zipCode) ) {

            var geocoder = new google.maps.Geocoder();

            geocoder.geocode( { 'address': zipCode }, function(results, status) {

                if (status === 'OK') {

                    var closestMarker = null;
                    var closestDistance = null;

                    $.each(app.locations.markers, function(index, marker) {

                        var markerDistance = google.maps.geometry.spherical.computeDistanceBetween(results[0].geometry.location, marker.position);

                        if ( closestDistance === null ) {

                            closestMarker = marker;
                            closestDistance = markerDistance;
                        }
                        else if ( markerDistance < closestDistance ) {

                            closestMarker = marker;
                            closestDistance = markerDistance;
                        }
                    });

                    if ( closestDistance < 80000 ) {

                        if ( app.locations.selectedMarker !== null ) {

                            app.locations.selectedMarker.setIcon(app.locations.settings.image);
                        }

                        if ( closestMarker !== null ) {

                            closestMarker.setIcon(app.locations.settings.imageSelected);

                            app.locations.selectedMarker = closestMarker;

                            app.locations.applyFilter(closestMarker.handle);
                        }
                    }
                    else {

                        app.locations.settings.$notification.html('Afstand te groot (> 80km)').animate({opacity: 1}, 100);
                    }
                }
                else {

                    app.locations.settings.$notification.html("Ongeldige postcode (2)").animate({opacity: 1}, 100);
                }
            });
        }
        else {
            app.locations.settings.$notification.html("Ongeldige postcode (1)").animate({opacity: 1}, 100);
        }
    }
};